import { I18nInfo } from '@/user/models'
import { ModelInfo } from '@/user/models/model-info'

const i18n = new I18nInfo('common')

const LEVEL = {
  ESSENTIAL: 'Essential',
  ASSOCIATE: 'Associate',
  PROFESSIONAL: 'Professional',
}

const STATE = {
  VALID: i18n.translate('certification.state.VALID'),
  EXPIRED: i18n.translate('certification.state.EXPIRED'),
}

/**
 * @class UserCertificationModel
 * @extends Model
 * @description 자격증 인증 모델
 */
export class UserCertificationModel {
  /**
   * @constructor
   * @param {number} id - 자격증 발급 아이디
   * @param {string} certificationIssueCode - 자격증 인증코드
   * @param {string} name - 자격증 명
   * @param {string} introduce - 자격증 설명
   * @param {string} level - 자격증 레벨 (ESSENTIAL, ASSOCIATE, PROFESSIONAL)
   * @param {Date} startAt - 자격 시작 일시
   * @param {Date} finishAt - 자격 만료 일시
   * @param {string} state - 자격 상태 (VALID, EXPIRED)
   */
  constructor(data) {
    this.id = data.id
    this.certificationIssueCode = data.certificationIssueCode
    this.name = data.name
    this.introduce = data.introduce
    this.level = LEVEL[data.level]
    this.originalLevel = data.level
    this.version = data.version
    this.startAt = data.startAt
    this.finishAt = data.finishAt
    this.state = STATE[data.state]
    this.originalState = data.state
  }

  get isValid() {
    return this.originalState === 'VALID'
  }
}

export class UserCertificationsInfo extends ModelInfo {
  constructor(data) {
    super(data)
    this.content = data.content.map((certification) => new UserCertificationModel(certification))
  }
}
